
import { MediaQueries } from 'UI'

export default theme => ({
  bannerGroup: {
    position: 'relative',
    width: '100%',
    paddingTop: '56.25%',
    backgroundImage: ({ PresentationVideoThumbnail }) => `url("${PresentationVideoThumbnail}")`,
    borderRadius: 8,
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100% 100%',
    overflow: 'hidden',
    boxShadow: '0 0 36px 0 rgba(194,212,230,0.23)'
  },
  overlay: {
    position: 'absolute',
    backgroundColor: 'rgba(0,0,0,0.25)',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column'
  },
  playSection: {
    position: 'absolute',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column'
  },
  playIconGroup: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 48,
    height: 48,
    backgroundColor: theme.neutral[400],
    borderRadius: '50%',
    transition: 'all 0.15s ease',
    cursor: 'pointer'
  },
  playIcon: {
    fontSize: 13,
    color: theme.primary[0],
    lineHeight: 0
  },
  [MediaQueries.tablet]: {
    bannerGroup: {
      marginTop: 28
    }
  },
  [MediaQueries.mobile]: {
    bannerGroup: {
      marginTop: 28
    }
  }
})
